import { Typography } from '@ovComponents/1-primative/typography/typography';
import { useThemeTokens } from '@providers/themeTokenProvider';
import { useBadgeTokens } from './badge.tokens';

export const colorMap = {
  neutral: 'neutral',
  negative: 'negative',
  warning: 'warning',
  positive: 'positive',
  gray: 'gray',
  supportOne: 'supportOne',
  supportTwo: 'supportTwo',
  supportThree: 'supportThree',
  supportFour: 'supportFour',
  supportFive: 'supportFive',
  supportSix: 'supportSix',
};

export type BadgeProps = {
  label: string;
  color?: keyof typeof colorMap;
  variant?: 'number' | 'text';
  backgroundColor?: string;
  textColorOverride?: string;
  sx?: any;
  testId?: string;
};

export const Badge = ({
  label,
  color = 'neutral',
  variant = 'text',
  sx = {},
  testId = 'badge',
}: BadgeProps) => {
  const { comp } = useThemeTokens(useBadgeTokens());
  const textColor =
    variant === 'number'
      ? comp.badge.number.textColor
      : comp.badge[variant][color].textColor;
  const bgColor =
    variant === 'number'
      ? comp.badge.number.backgroundColor
      : comp.badge[variant][color].backgroundColor;
  const borderColor =
    variant === 'number'
      ? comp.badge.number.borderColor
      : comp.badge[variant][color].borderColor;
  const borderStyle = comp.badge[variant].borderStyle;
  const borderWidth = comp.badge[variant].borderWidth;
  return (
    <span data-testid={testId}>
      <Typography
        data-testid={`${testId}-text`}
        variant='labelSmall'
        sx={{
          minHeight: variant === 'number' ? '16px' : '20px',
          display: 'inline-block',
          textAlign: 'center',
          color: textColor,
          backgroundColor: bgColor,
          borderRadius: comp.badge[variant].borderRadius,
          borderStyle,
          borderWidth,
          borderColor,
          minWidth: '16px',
          alignContent: 'center',
          padding: '1px 4px 1px 4px',
          ...sx,
        }}
      >
        {label}
      </Typography>
    </span>
  );
};
